import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { api, get, put, post, getBranchOwner } from "@config";
import { Modal } from 'react-bootstrap';
import Currency from "react-currency-formatter";
import {
    StyledCard,
    StyledCardHeader,
    SectionTitle,
    TableWrapper,
    ActionButton,
    ScreenContainer,
    ScreenContent,
    HeroHeader,
    HeroHeaderTitle,
    HeroIcon,
    CardList,
    CardListItem,
    CardListItemHeader,
    CardListItemActions,
    DesktopOnly,
    MobileOnly,
} from '../emit/components/styles';
import ServiceFinder from '../components/ServiceFinder';

function StatusBadge({ status, msg }) {
    switch (status) {
        case 0:
            return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <span style={{ background: '#FEF0C7', color: '#DC6803', padding: '4px 8px', borderRadius: '16px', fontSize: '0.75rem', fontWeight: 600, width: 'fit-content', display: 'inline-flex', alignItems: 'flex-start', gap: '4px' }}>
                        <i className="fas fa-clock"></i> Pendente
                    </span>
                    <small style={{ color: '#667085', fontSize: '0.75rem', lineHeight: 1.2 }}>Aguardando prefeitura.</small>
                </div>
            );
        case 1:
            return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <span style={{ background: '#FEE4E2', color: '#D92D20', padding: '4px 8px', borderRadius: '16px', fontSize: '0.75rem', fontWeight: 600, width: 'fit-content', display: 'inline-flex', alignItems: 'flex-start', gap: '4px' }}>
                        <i className="fas fa-times-circle"></i> Rejeitada
                    </span>
                    <small style={{ color: '#667085', fontSize: '0.75rem', lineHeight: 1.2 }} title={msg}>
                        {msg && msg.length > 28 ? msg.substring(0, 28) + '...' : (msg || "Erro na emissão")}
                    </small>
                </div>
            );
        case 2:
            return <span style={{ background: '#F2F4F7', color: '#344054', padding: '4px 8px', borderRadius: '16px', fontSize: '0.75rem', fontWeight: 600, width: 'fit-content' }}>Cancelada</span>;
        case 3:
            return (
                <span style={{ background: '#D1FADF', color: '#027A48', padding: '4px 8px', borderRadius: '16px', fontSize: '0.75rem', fontWeight: 600, width: 'fit-content', display: 'inline-flex', alignItems: 'flex-start', gap: '4px' }}>
                    <i className="fas fa-check-circle"></i> Autorizada
                </span>
            );
        case 4:
            return <span style={{ background: '#E0F2FE', color: '#026AA2', padding: '4px 8px', borderRadius: '16px', fontSize: '0.75rem', fontWeight: 600, width: 'fit-content' }}>Inutilizada</span>;
        case 5:
            return <span style={{ background: '#FEF0C7', color: '#B54708', padding: '4px 8px', borderRadius: '16px', fontSize: '0.75rem', fontWeight: 600, width: 'fit-content' }}>Denegada</span>;
        default:
            return <span style={{ background: '#F2F4F7', color: '#344054', padding: '4px 8px', borderRadius: '16px', fontSize: '0.75rem', fontWeight: 600, width: 'fit-content' }}>Desconhecido</span>;
    }
}

function ChannelBadge({ channel }) {
    if (channel === 'dps') {
        return (
            <span style={{
                background: '#DBEAFE', color: '#1E3A8A',
                padding: '3px 8px', borderRadius: '16px',
                fontSize: '0.72rem', fontWeight: 700,
                display: 'inline-flex', alignItems: 'center', gap: '4px'
            }}>
                <i className="fas fa-network-wired" style={{ fontSize: '0.65rem' }}></i> DPS
            </span>
        );
    }
    return (
        <span style={{
            background: '#F2F4F7', color: '#344054',
            padding: '3px 8px', borderRadius: '16px',
            fontSize: '0.72rem', fontWeight: 700
        }}>
            RPS
        </span>
    );
}

function DownloadFilesComponent({ item, compact = false }) {
    if (!item.pdf_url && !item.xml_url) {
        return <span style={{ color: '#98A2B3', fontSize: '0.85rem', width: compact ? '100%' : 'auto' }}>-</span>;
    }

    return (
        <div style={{ display: 'flex', gap: '8px', width: compact ? '100%' : 'auto', flexDirection: compact ? 'column' : 'row' }}>
            <ActionButton
                variant={item.pdf_url ? 'danger' : 'secondary'}
                disabled={!item.pdf_url}
                onClick={() => window.open(item.pdf_url, '_blank')}
                style={{ padding: '6px 10px', fontSize: '0.8rem' }}
                $fullWidth={compact}
                title='Download PDF'
            >
                <i className="fas fa-file-pdf"></i>
            </ActionButton>
            <ActionButton
                variant={item.xml_url ? 'primary' : 'secondary'}
                disabled={!item.xml_url}
                onClick={() => window.open(item.xml_url, '_blank')}
                style={{ padding: '6px 10px', fontSize: '0.8rem', background: item.xml_url ? '#026AA2' : 'transparent', borderColor: item.xml_url ? '#026AA2' : '#D0D5DD' }}
                $fullWidth={compact}
                title='Download XML'
            >
                <i className="fas fa-file-code"></i>
            </ActionButton>

        </div>
    );
}

// Motivos seguem a tabela padrão ABRASF / Nacional (1, 2, 3, 4, 5 e 9)
const CANCEL_REASON_OPTIONS = [
    { value: "erro-emissao", reasonCode: "1", label: "Erro na emissão" },
    { value: "servico-nao-prestado", reasonCode: "2", label: "Serviço não prestado" },
    { value: "erro-assinatura", reasonCode: "3", label: "Erro de assinatura" },
    { value: "duplicidade-emissao", reasonCode: "4", label: "Duplicidade da nota" },
    { value: "erro-processamento", reasonCode: "5", label: "Erro de processamento" },
    { value: "outros", reasonCode: "9", label: "Outros (Padrão Nacional)" },
];

// ─── Filter helpers ─────────────────────────────────────────────────────────

const EMPTY_FILTERS = {
    search: "",
    status: "",         // "" = todos | 0..5
    channel: "",        // "" | "rps" | "dps"
    dateFrom: "",
    dateTo: "",
    valueMin: "",
    valueMax: "",
};

function applyFilters(notes, filters) {
    return notes.filter(item => {
        const taker_name = ((item.taker && item.taker.name) || "").toLowerCase();
        const search_lc = filters.search.trim().toLowerCase();
        if (search_lc && !taker_name.includes(search_lc)) return false;

        if (filters.status !== "" && String(item.status) !== String(filters.status)) return false;

        if (filters.channel && (item.channel || "rps") !== filters.channel) return false;

        const rawDate = item.created_at || item.emission_date || item.send_date;
        if (rawDate) {
            const d = new Date(rawDate);
            if (filters.dateFrom && d < new Date(filters.dateFrom)) return false;
            if (filters.dateTo) {
                const to = new Date(filters.dateTo);
                to.setHours(23, 59, 59, 999);
                if (d > to) return false;
            }
        } else if (filters.dateFrom || filters.dateTo) {
            return false;
        }

        const val = parseFloat((item.service && item.service.value) || 0);
        if (filters.valueMin !== "" && val < parseFloat(filters.valueMin)) return false;
        if (filters.valueMax !== "" && val > parseFloat(filters.valueMax)) return false;

        return true;
    });
}

export default function ListNfse() {
    const history = useHistory();
    const [initializing, setInitializing] = useState(true);
    const branch = getBranchOwner();

    useEffect(() => {
        if (!branch) return;
        
        const hasPermission = branch.permissions && branch.permissions.nfse === 3;
        
        if (!hasPermission) {
            window.location.href = '/nfse/enable';
        } else {
            setInitializing(false);
        }
    }, [branch]);

    if (initializing) {
        return null;
    }

    const [listNotes, setListNotes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [filters, setFilters] = useState(EMPTY_FILTERS);
    const [showFilters, setShowFilters] = useState(false);
    const [showCsvModal, setShowCsvModal] = useState(false);
    const [csvFile, setCsvFile] = useState(null);
    const [uploadingCsv, setUploadingCsv] = useState(false);
    const [csvResult, setCsvResult] = useState(null);
    const [csvPreview, setCsvPreview] = useState(null);
    const [csvRowsData, setCsvRowsData] = useState([]);
    const [progress, setProgress] = useState(0);
    const [showFinder, setShowFinder] = useState(false);
    const [showSyncModal, setShowSyncModal] = useState(false);
    const [syncing, setSyncing] = useState(false);
    const [syncStats, setSyncStats] = useState(null);
    const [syncError, setSyncError] = useState("");
    const [syncForm, setSyncForm] = useState({
        startNumber: "",
        endNumber: "",
        series: "1",
        recuperar: "sim",
    });

    // Cancellation states
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [noteToCancel, setNoteToCancel] = useState(null);
    const [selectedCancelReason, setSelectedCancelReason] = useState(CANCEL_REASON_OPTIONS[0].value);
    const [cancelDescription, setCancelDescription] = useState("");
    const [cancelling, setCancelling] = useState(false);

    const loadData = () => {
        setLoading(true);
        const branch = getBranchOwner();
        const url = `${api.nfse.nfse}?branch_owner=${branch.id}`;
        get(url, (resp) => {
            setListNotes(resp);
            setLoading(false);
        }, () => setLoading(false));
    };

    const activeFilterCount = Object.entries(filters).filter(([k, v]) => v !== "").length;
    const displayedNotes = applyFilters(listNotes, filters);

    const extractErrorMessage = (err, fallback = "Erro ao comunicar com o servidor.") => {
        if (!err) return fallback;
        if (err.response && err.response.data) {
            const data = err.response.data;
            if (typeof data === "string") return data;
            if (data.error) return data.error;
            if (data.detail) return data.detail;
            if (Array.isArray(data)) return data.join(" | ");
            const values = Object.values(data);
            if (values.length) return values.join(" | ");
        }
        if (err.message) return err.message;
        return fallback;
    };

    const handleCancelNote = () => {
        if (!noteToCancel || cancelling) return;

        setCancelling(true);
        const branch = getBranchOwner();
        const url = `${api.nfse.nfse}${noteToCancel.id}/cancel/?branch_owner=${branch.id}`;
        const selectedReason = CANCEL_REASON_OPTIONS.find(opt => opt.value === selectedCancelReason) || CANCEL_REASON_OPTIONS[0];
        const justification = cancelDescription.trim();

        if (!justification) {
            alert("Informe uma justificativa para o cancelamento.");
            setCancelling(false);
            return;
        }

        if (justification.length < 15 || justification.length > 255) {
            alert("A justificativa deve conter entre 15 e 255 caracteres.");
            setCancelling(false);
            return;
        }

        const payload = {
            codigo: "110111",
            descricao: justification,
            motivo: selectedReason.reasonCode,
        };

        post(url, payload, (resp) => {
            setCancelling(false);
            setShowCancelModal(false);
            setNoteToCancel(null);
            loadData();
        }, (err) => {
            setCancelling(false);
            console.error("Erro ao cancelar nota:", err);
            loadData();
        });
    };

    const openSyncModal = () => {
        setShowSyncModal(true);
        setSyncStats(null);
        setSyncError("");
    };

    const handleSyncFieldChange = (field, value) => {
        setSyncForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSyncMissingNotes = () => {
        const start = (syncForm.startNumber || "").trim();
        const end = (syncForm.endNumber || "").trim();
        if (!start || !end) {
            setSyncError("Informe a numeração inicial e final para buscar as notas.");
            return;
        }

        const branch = getBranchOwner();
        const params = new URLSearchParams({
            branch_owner: branch.id,
            start_number: start,
            end_number: end,
            series: (syncForm.series || "1").trim() || "1",
            recuperar: syncForm.recuperar || "sim",
        });

        const url = `${api.nfse.nfse}adapt/?${params.toString()}`;
        setSyncing(true);
        setSyncStats(null);
        setSyncError("");

        get(url, (resp) => {
            setSyncing(false);
            setSyncStats(resp);
            loadData();
        }, (err) => {
            setSyncing(false);
            setSyncStats(null);
            setSyncError(extractErrorMessage(err));
        });
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        // search is now client-side only; no API call needed
    };

    const handleClearSearch = () => {
        setFilters(EMPTY_FILTERS);
    };

    const handleUploadCsv = async () => {
        if (!csvFile || csvRowsData.length === 0) return alert("Planilha vazia ou inválida!");
        setUploadingCsv(true);
        setProgress(0);

        const branch = getBranchOwner();
        const items = [];

        for (let i = 0; i < csvRowsData.length; i++) {
            const row = csvRowsData[i];

            let cpf_cnpj = (row.cpf_cnpj || "").replace(/\./g, "").replace(/-/g, "").replace(/\//g, "");
            if (!cpf_cnpj) continue;

            let value_float = parseFloat((row.valor || "0").replace(",", "."));
            if (isNaN(value_float)) value_float = 0;

            let emission_date = "";
            let raw_date = row.data_da_emissao || "";
            if (raw_date.includes("/")) {
                const d = raw_date.split("/");
                if (d.length === 3) emission_date = `${d[2]}-${d[1]}-${d[0]} 10:00:00`;
            } else if (raw_date.includes("-")) {
                emission_date = `${raw_date} 10:00:00`;
            }

            const payload = {
                taker: {
                    cpf_cnpj: cpf_cnpj,
                    name: row['nome/razao social'],
                    state: row.estado,
                    city_location: row.cidade,
                },
                service: {
                    value: value_float,
                    description: row.descricao_do_servico,
                    item_list_service: row.sub_codigo_do_servico,
                    service_code: row.codigo_do_servico,
                    aliq_iss: 0,
                },
                rps: {
                    rps_nat_op: "1",
                    rps_type: 1
                }
            };
            if (emission_date) payload.rps.emission_date = emission_date;
            items.push(payload);
        }

        if (items.length === 0) {
            setUploadingCsv(false);
            return alert("Nenhuma linha válida encontrada no CSV.");
        }

        // Indicador visual de progresso (lote agrupado)
        setProgress(Math.floor(csvRowsData.length / 2));

        const url = `${api.nfse.nfse}bulk-import/?branch_owner=${branch.id}`;

        post(url, { items },
            (resp) => {
                setUploadingCsv(false);
                setShowCsvModal(false);
                setCsvFile(null);
                setCsvPreview(null);
                setCsvRowsData([]);
                setProgress(0);
                alert("Lote recebido. O processamento iniciou em segundo plano. Recarregue a página em alguns minutos para ver o status atualizado.");
                loadData(searchTerm);
            },
            (err) => {
                setProgress(0);
                setUploadingCsv(false);
                let msg = "Erro na comunicação com o servidor.";
                if (err && err.response && err.response.data) {
                    msg = err.response.data.error || err.response.data;
                }
                if (typeof msg === 'object') msg = Object.values(msg).join(' - ') || JSON.stringify(msg);
                alert(msg);
            }
        );
    };

    const downloadCsvTemplate = () => {
        const header = "cpf_cnpj;nome/razao social;estado;cidade;sub_codigo_do_servico;codigo_do_servico;valor;descricao_do_servico;data_da_emissao\n";
        const row1 = "12345678000190;Empresa Exemplo LTDA;PA;Belem;1.04;0;150,10;Assistencia Tecnica;06/06/2026\n";
        const row2 = "98765432000109;Maria Joana;SP;So Paulo;1.04;0;99,50;Manutencao de equipamento;01/05/2026\n";

        const blob = new Blob([header + row1 + row2], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "Modelo_Lote_NFSe.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const renderActions = (item, compact = false) => {
        const branch = getBranchOwner();
        const buttonProps = compact ? { $fullWidth: true } : {};

        const duplicate = () => {
            const url = `${api.nfse.nfse}${item.id}/duplicate/?branch_owner=${branch.id}`;
            setLoading(true);
            get(url, (resp) => {
                localStorage.setItem('nfseDuplicateData', JSON.stringify(resp));
                history.push('/nfse');
            }, () => setLoading(false));
        };

        const refreshStatus = () => {
            const url = `${api.nfse.nfse}${item.id}/get-status/?branch_owner=${branch.id}`;
            setLoading(true);
            put(url, {}, () => {
                loadData();
            }, () => setLoading(false));
        };

        const askCancel = () => {
            setNoteToCancel(item);
            setSelectedCancelReason(CANCEL_REASON_OPTIONS[0].value);
            setCancelDescription("");
            setShowCancelModal(true);
        };

        return (
            <React.Fragment>
                <DownloadFilesComponent item={item} compact={compact} />
                <ActionButton
                    variant="warning"
                    onClick={duplicate}
                    style={{ padding: '6px 10px', fontSize: '0.8rem', background: '#F79009', borderColor: '#F79009', color: '#fff' }}
                    title='Replicar NFS-e'
                    {...buttonProps}
                >
                    <i className="fas fa-copy"></i>
                </ActionButton>
                <ActionButton
                    variant="primary"
                    onClick={refreshStatus}
                    style={{ padding: '6px 10px', fontSize: '0.8rem', background: '#3b82f6', borderColor: '#3b82f6', color: '#fff' }}
                    title='Consultar/Atualizar Status'
                    {...buttonProps}
                >
                    <i className="fas fa-sync"></i>
                </ActionButton>
                {item.status === 3 && (
                    <ActionButton
                        variant="danger"
                        onClick={askCancel}
                        style={{ padding: '6px 10px', fontSize: '0.8rem', background: '#D92D20', borderColor: '#D92D20', color: '#fff' }}
                        title='Cancelar NFS-e'
                        {...buttonProps}
                    >
                        <i className="fas fa-ban"></i>
                    </ActionButton>
                )}
            </React.Fragment>
        );
    };

    const formatSerieNumber = (item) => item.serie ? `${item.serie} - ${item.number}` : 'N/A';

    const formatEmissionDate = (item) => {
        const dt = item.created_at || item.emission_date || item.send_date;
        return dt ? new Date(dt).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'N/A';
    };

    return (
        <ScreenContainer>
            <ScreenContent>
                <HeroHeader>
                    <HeroHeaderTitle>
                        <HeroIcon>
                            <i className="fas fa-list-ul"></i>
                        </HeroIcon>
                        <div>
                            <h1 className="m-0" style={{ fontWeight: 800, fontSize: '1.75rem', color: '#101828' }}>Lista de NFS-e</h1>
                            <span style={{ color: '#475467', fontSize: '0.95rem', fontWeight: 500 }}>
                                Consulte e acompanhe as notas fiscais emitidas
                            </span>
                        </div>
                    </HeroHeaderTitle>
                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                        <ActionButton
                            variant="secondary"
                            onClick={openSyncModal}
                            style={{ background: '#1D4ED8', borderColor: '#1D4ED8', color: '#fff', fontWeight: 600 }}
                            $stackedOnMobile
                        >
                            <i className="fas fa-cloud-download-alt" style={{ marginRight: '8px' }}></i>
                            Buscar no Migrate
                        </ActionButton>
                        <ActionButton variant="primary" onClick={() => setShowCsvModal(true)} style={{ background: '#027A48', borderColor: '#027A48', fontWeight: 600 }} $stackedOnMobile>
                            <i className="fas fa-file-csv" style={{ marginRight: '8px' }}></i>
                            Importar Lote (CSV)
                        </ActionButton>
                    </div>
                </HeroHeader>

                <Modal
                    show={showSyncModal}
                    onHide={() => !syncing && setShowSyncModal(false)}
                    centered
                >
                    <Modal.Header closeButton={!syncing}>
                        <Modal.Title style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fas fa-database" style={{ color: '#1D4ED8' }}></i>
                            Buscar notas diretamente no Migrate
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p style={{ fontSize: '0.9rem', color: '#475467' }}>
                            Informe o intervalo de numeração e série que deseja sincronizar. O sistema consulta o Migrate,
                            salva notas inexistentes e atualiza o status das já cadastradas.
                        </p>
                        {syncError && (
                            <div className="alert alert-danger" style={{ fontSize: '0.85rem' }}>
                                <i className="fas fa-exclamation-circle mr-2"></i>
                                {syncError}
                            </div>
                        )}
                        {syncStats && (
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                                gap: '12px',
                                marginBottom: '12px'
                            }}>
                                <div style={{ background: '#EFF6FF', borderRadius: '10px', padding: '12px' }}>
                                    <small style={{ textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1D4ED8' }}>Total encontrado</small>
                                    <h4 style={{ margin: '8px 0 0', fontWeight: 700 }}>{syncStats.total_found || 0}</h4>
                                </div>
                                <div style={{ background: '#ECFDF3', borderRadius: '10px', padding: '12px' }}>
                                    <small style={{ textTransform: 'uppercase', letterSpacing: '0.08em', color: '#027A48' }}>Criadas</small>
                                    <h4 style={{ margin: '8px 0 0', fontWeight: 700 }}>{syncStats.created || 0}</h4>
                                </div>
                                <div style={{ background: '#FFF7ED', borderRadius: '10px', padding: '12px' }}>
                                    <small style={{ textTransform: 'uppercase', letterSpacing: '0.08em', color: '#B45309' }}>Atualizadas</small>
                                    <h4 style={{ margin: '8px 0 0', fontWeight: 700 }}>{syncStats.updated || 0}</h4>
                                </div>
                            </div>
                        )}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                            gap: '12px'
                        }}>
                            <div>
                                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#344054' }}>Número inicial *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    min="1"
                                    value={syncForm.startNumber}
                                    onChange={(e) => handleSyncFieldChange('startNumber', e.target.value)}
                                    placeholder="Ex.: 100"
                                    disabled={syncing}
                                />
                            </div>
                            <div>
                                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#344054' }}>Número final *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    min="1"
                                    value={syncForm.endNumber}
                                    onChange={(e) => handleSyncFieldChange('endNumber', e.target.value)}
                                    placeholder="Ex.: 150"
                                    disabled={syncing}
                                />
                            </div>
                            <div>
                                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#344054' }}>Série</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={syncForm.series}
                                    onChange={(e) => handleSyncFieldChange('series', e.target.value)}
                                    placeholder="Ex.: 1"
                                    disabled={syncing}
                                />
                            </div>
                        </div>
                        <div style={{ marginTop: '16px', background: '#F9FAFB', borderRadius: '8px', padding: '12px' }}>
                            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#344054', display: 'block', marginBottom: '6px' }}>
                                Quando não existir na base local
                            </label>
                            <select
                                className="form-control"
                                value={syncForm.recuperar}
                                onChange={(e) => handleSyncFieldChange('recuperar', e.target.value)}
                                disabled={syncing}
                            >
                                <option value="sim">Criar automaticamente</option>
                                <option value="nao">Apenas consultar status</option>
                            </select>
                            <small style={{ color: '#667085', fontSize: '0.75rem', display: 'block', marginTop: '4px' }}>
                                Escolha "Criar" para importar notas inexistentes. "Apenas consultar" atualiza somente as notas já cadastradas.
                            </small>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: 'none' }}>
                        <button
                            className="btn btn-link"
                            style={{ color: '#475467', fontWeight: 600 }}
                            onClick={() => !syncing && setShowSyncModal(false)}
                            disabled={syncing}
                        >
                            Fechar
                        </button>
                        <ActionButton
                            variant="primary"
                            onClick={handleSyncMissingNotes}
                            disabled={syncing}
                            style={{ background: '#1D4ED8', borderColor: '#1D4ED8', minWidth: '180px', fontWeight: 600 }}
                        >
                            {syncing ? (
                                <React.Fragment><i className="fas fa-circle-notch fa-spin mr-2"></i> Buscando...</React.Fragment>
                            ) : (
                                <React.Fragment><i className="fas fa-search mr-2"></i> Buscar notas</React.Fragment>
                            )}
                        </ActionButton>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={showCancelModal}
                    onHide={() => !cancelling && setShowCancelModal(false)}
                    centered
                >
                    <Modal.Header closeButton={!cancelling}>
                        <Modal.Title style={{ color: '#D92D20', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fas fa-exclamation-triangle"></i> Confirmar Cancelamento
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p style={{ fontSize: '1rem', color: '#344054' }}>
                            Você está prestes a cancelar a NFS-e <strong>{noteToCancel && noteToCancel.serie} - {noteToCancel && noteToCancel.number}</strong>.
                        </p>
                        <p style={{ fontSize: '0.9rem', color: '#667085' }}>
                            Esta ação é irreversível e requer autorização da prefeitura através do sistema InvoiCy. Escolha o motivo mais adequado,
                            descreva a justificativa abaixo e confirme para concluir o cancelamento.
                        </p>
                        <div style={{ background: '#FFFAEB', border: '1px solid #FEDF89', borderRadius: '8px', padding: '16px', marginTop: '16px' }}>
                            <label style={{ fontSize: '0.85rem', color: '#B54708', fontWeight: 600, marginBottom: '8px', display: 'block' }}>
                                <i className="fas fa-info-circle"></i> Motivo do Cancelamento:
                            </label>
                            <select
                                className="form-control"
                                value={selectedCancelReason}
                                onChange={(e) => setSelectedCancelReason(e.target.value)}
                                disabled={cancelling}
                                style={{ fontSize: '0.9rem', borderRadius: '6px', borderColor: '#FEDF89' }}
                            >
                                {CANCEL_REASON_OPTIONS.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {`${option.reasonCode} - ${option.label}`}
                                    </option>
                                ))}
                            </select>
                            <label style={{ marginTop: '16px', fontWeight: 600, fontSize: '0.85rem', color: '#B54708' }}>
                                Justificativa detalhada
                            </label>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder="Descreva o motivo do cancelamento"
                                value={cancelDescription}
                                onChange={(e) => setCancelDescription(e.target.value)}
                                disabled={cancelling}
                                maxLength={255}
                                style={{ fontSize: '0.9rem', borderRadius: '6px', borderColor: '#FEDF89', resize: 'none' }}
                            />
                            <small style={{ display: 'block', marginTop: '4px', color: '#B54708', fontSize: '0.8rem' }}>
                                A justificativa deve ter entre 15 e 255 caracteres. Atual: {cancelDescription.length}
                            </small>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ borderTop: 'none', padding: '16px 24px' }}>
                        <button
                            className="btn btn-link"
                            onClick={() => {
                                setShowCancelModal(false);
                                setCancelDescription("");
                            }}
                            disabled={cancelling}
                            style={{ textDecoration: 'none', color: '#475467', fontWeight: 600 }}
                        >
                            Voltar
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={handleCancelNote}
                            disabled={cancelling || !cancelDescription.trim()}
                            style={{ background: '#D92D20', borderColor: '#D92D20', fontWeight: 600, padding: '10px 18px', borderRadius: '8px' }}
                        >
                            {cancelling ? (
                                <React.Fragment><i className="fas fa-spinner fa-spin mr-2"></i> Cancelando...</React.Fragment>
                            ) : 'Confirmar e Cancelar'}
                        </button>
                    </Modal.Footer>
                </Modal>

                <ServiceFinder show={showFinder} onHide={() => setShowFinder(false)} />

                <StyledCard>
                    {/* ── Cabeçalho do card com filtros avançados ────────────────── */}
                    <StyledCardHeader style={{ flexDirection: 'column', gap: '16px' }}>
                        {/* Linha 1: título + barra de busca + botão filtros */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', width: '100%' }}>
                            <div>
                                <SectionTitle><i className="fas fa-receipt"></i> Registros de Notas Fiscais</SectionTitle>
                                <span className="text-secondary" style={{ fontSize: '0.9rem' }}>
                                    {activeFilterCount > 0
                                        ? <span style={{ color: '#026AA2', fontWeight: 600 }}>{displayedNotes.length} resultado{displayedNotes.length !== 1 ? 's' : ''} filtrado{displayedNotes.length !== 1 ? 's' : ''}</span>
                                        : 'Histórico completo das emissões'
                                    }
                                </span>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                                {/* Busca rápida por tomador */}
                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                    <i className="fas fa-search" style={{ position: 'absolute', left: '10px', color: '#98A2B3', fontSize: '0.85rem', pointerEvents: 'none' }} />
                                    <input
                                        type="text"
                                        placeholder="Buscar tomador..."
                                        value={filters.search}
                                        onChange={e => setFilters({ ...filters, search: e.target.value })}
                                        style={{
                                            paddingLeft: '32px', paddingRight: '12px', paddingTop: '9px', paddingBottom: '9px',
                                            borderRadius: '8px', border: '1px solid #D0D5DD',
                                            fontSize: '0.875rem', width: '220px', outline: 'none',
                                            transition: 'border-color 0.15s',
                                        }}
                                        onFocus={e => e.target.style.borderColor = '#026AA2'}
                                        onBlur={e => e.target.style.borderColor = '#D0D5DD'}
                                    />
                                </div>
                                {/* Botão filtros avançados */}
                                <button
                                    type="button"
                                    onClick={() => setShowFilters(p => !p)}
                                    style={{
                                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                                        padding: '9px 14px', borderRadius: '8px', fontSize: '0.875rem', fontWeight: 600, cursor: 'pointer',
                                        border: showFilters || activeFilterCount > 0 ? '1.5px solid #026AA2' : '1.5px solid #D0D5DD',
                                        background: showFilters ? '#EFF8FF' : activeFilterCount > 0 ? '#EFF8FF' : '#fff',
                                        color: showFilters || activeFilterCount > 0 ? '#026AA2' : '#344054',
                                        transition: 'all 0.15s',
                                    }}
                                >
                                    <i className={`fas fa-sliders-h`} />
                                    Filtros
                                    {activeFilterCount > 0 && (
                                        <span style={{
                                            background: '#026AA2', color: '#fff',
                                            borderRadius: '50%', width: '18px', height: '18px',
                                            fontSize: '0.7rem', fontWeight: 700,
                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                        }}>{activeFilterCount}</span>
                                    )}
                                </button>
                                {activeFilterCount > 0 && (
                                    <button
                                        type="button"
                                        onClick={handleClearSearch}
                                        style={{
                                            background: 'none', border: 'none', cursor: 'pointer',
                                            color: '#D92D20', fontSize: '0.82rem', fontWeight: 600,
                                            display: 'inline-flex', alignItems: 'center', gap: '4px',
                                            padding: '4px 2px',
                                        }}
                                    >
                                        <i className="fas fa-times" /> Limpar filtros
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Linha 2: painel de filtros avançados (colapsável) */}
                        {showFilters && (
                            <div style={{
                                width: '100%', background: '#F9FAFB', borderRadius: '12px',
                                border: '1px solid #EAECF0', padding: '16px 20px',
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))',
                                gap: '14px',
                                animation: 'fadeInDown 0.18s ease',
                            }}>
                                {/* Status */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#344054', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Status</label>
                                    <select
                                        value={filters.status}
                                        onChange={e => setFilters({ ...filters, status: e.target.value })}
                                        style={{ padding: '8px 10px', borderRadius: '8px', border: '1px solid #D0D5DD', fontSize: '0.875rem', background: '#fff', cursor: 'pointer', outline: 'none' }}
                                    >
                                        <option value="">Todos</option>
                                        <option value="3">Autorizada</option>
                                        <option value="0">Pendente</option>
                                        <option value="1">Rejeitada</option>
                                        <option value="2">Cancelada</option>
                                        <option value="5">Denegada</option>
                                        <option value="4">Inutilizada</option>
                                    </select>
                                </div>

                                {/* Canal */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#344054', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Canal</label>
                                    <select
                                        value={filters.channel}
                                        onChange={e => setFilters({ ...filters, channel: e.target.value })}
                                        style={{ padding: '8px 10px', borderRadius: '8px', border: '1px solid #D0D5DD', fontSize: '0.875rem', background: '#fff', cursor: 'pointer', outline: 'none' }}
                                    >
                                        <option value="">Todos</option>
                                        <option value="dps">DPS (Padrão Nacional)</option>
                                        <option value="rps">RPS (Legado)</option>
                                    </select>
                                </div>

                                {/* Data de — */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#344054', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Emissão de</label>
                                    <input
                                        type="date"
                                        value={filters.dateFrom}
                                        onChange={e => setFilters({ ...filters, dateFrom: e.target.value })}
                                        style={{ padding: '8px 10px', borderRadius: '8px', border: '1px solid #D0D5DD', fontSize: '0.875rem', background: '#fff', outline: 'none', cursor: 'pointer' }}
                                    />
                                </div>

                                {/* Data até */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#344054', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Emissão até</label>
                                    <input
                                        type="date"
                                        value={filters.dateTo}
                                        onChange={e => setFilters({ ...filters, dateTo: e.target.value })}
                                        style={{ padding: '8px 10px', borderRadius: '8px', border: '1px solid #D0D5DD', fontSize: '0.875rem', background: '#fff', outline: 'none', cursor: 'pointer' }}
                                    />
                                </div>

                                {/* Valor mínimo */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#344054', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Valor mínimo</label>
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <span style={{ position: 'absolute', left: '10px', fontSize: '0.78rem', color: '#667085', fontWeight: 600 }}>R$</span>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            placeholder="0,00"
                                            value={filters.valueMin}
                                            onChange={e => setFilters({ ...filters, valueMin: e.target.value })}
                                            style={{ paddingLeft: '30px', paddingRight: '10px', paddingTop: '8px', paddingBottom: '8px', borderRadius: '8px', border: '1px solid #D0D5DD', fontSize: '0.875rem', background: '#fff', outline: 'none', width: '100%' }}
                                        />
                                    </div>
                                </div>

                                {/* Valor máximo */}
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#344054', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Valor máximo</label>
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <span style={{ position: 'absolute', left: '10px', fontSize: '0.78rem', color: '#667085', fontWeight: 600 }}>R$</span>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            placeholder="9.999,00"
                                            value={filters.valueMax}
                                            onChange={e => setFilters({ ...filters, valueMax: e.target.value })}
                                            style={{ paddingLeft: '30px', paddingRight: '10px', paddingTop: '8px', paddingBottom: '8px', borderRadius: '8px', border: '1px solid #D0D5DD', fontSize: '0.875rem', background: '#fff', outline: 'none', width: '100%' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </StyledCardHeader>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '48px 16px', background: '#F9FAFB', borderRadius: '8px' }}>
                            <i className="fas fa-circle-notch fa-spin text-info mb-3" style={{ fontSize: '2.5rem' }}></i>
                            <p className="m-0 text-secondary" style={{ fontWeight: 500 }}>Carregando as notas emitidas...</p>
                        </div>
                    ) : displayedNotes.length === 0 && activeFilterCount > 0 ? (
                        <div style={{ textAlign: 'center', padding: '48px 16px', background: '#F9FAFB', borderRadius: '8px' }}>
                            <i className="fas fa-filter" style={{ fontSize: '2rem', color: '#98A2B3', marginBottom: '12px', display: 'block' }}></i>
                            <p className="m-0" style={{ fontWeight: 600, color: '#344054' }}>Nenhuma nota corresponde aos filtros aplicados.</p>
                            <button onClick={handleClearSearch} style={{ marginTop: '12px', background: 'none', border: 'none', color: '#026AA2', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem' }}>
                                <i className="fas fa-times mr-1" /> Limpar filtros
                            </button>
                        </div>
                    ) : (
                        <React.Fragment>
                            <MobileOnly>
                                {displayedNotes.length === 0 ? (
                                    <CardList>
                                        <CardListItem>
                                            <CardListItemHeader>
                                                <div>
                                                    <strong style={{ color: '#101828' }}>Nenhuma nota encontrada</strong>
                                                    <p style={{ margin: 0, color: '#667085', fontSize: '0.9rem' }}>As NFS-e emitidas aparecerão aqui.</p>
                                                </div>
                                            </CardListItemHeader>
                                        </CardListItem>
                                    </CardList>
                                ) : (
                                    <CardList>
                                        {displayedNotes.map((item, index) => (
                                            <CardListItem key={item.id || index}>
                                                <CardListItemHeader>
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                        <strong style={{ color: '#101828' }}>{formatSerieNumber(item)}</strong>
                                                        <span style={{ color: '#667085', fontSize: '0.9rem' }}>{item.taker ? item.taker.name : 'N/A'}</span>
                                                    </div>
                                                    <StatusBadge status={item.status} msg={item.description} />
                                                </CardListItemHeader>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.9rem', color: '#475467' }}>
                                                    <span><strong>Data:</strong> {formatEmissionDate(item)}</span>
                                                    <span><strong>Descrição:</strong> {item.service ? item.service.description : 'N/A'}</span>
                                                    <span><strong>Valor:</strong> {item.service && item.service.value ? <Currency quantity={item.service.value} currency="BRL" /> : 'N/A'}</span>
                                                    <span><strong>Canal:</strong> <ChannelBadge channel={item.channel} /></span>
                                                </div>
                                                <CardListItemActions>
                                                    {renderActions(item, true)}
                                                </CardListItemActions>
                                            </CardListItem>
                                        ))}
                                    </CardList>
                                )}
                            </MobileOnly>
                            <DesktopOnly>
                                <TableWrapper>
                                    <table>
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Série / Nº</th>
                                        <th>Data de Emissão</th>
                                        <th>Tomador</th>
                                        <th>Descrição do Serviço</th>
                                        <th>Valor</th>
                                        <th>Canal</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {displayedNotes.length === 0 ? (
                                        <tr>
                                            <td colSpan="6" style={{ textAlign: 'center', padding: '32px 16px', background: '#F9FAFB' }}>
                                                <i className="fas fa-file-invoice text-secondary mb-2" style={{ fontSize: '2rem' }}></i>
                                                <p className="m-0 text-secondary" style={{ fontWeight: 500 }}>Nenhuma nota encontrada no momento.</p>
                                            </td>
                                        </tr>
                                    ) : (
                                        displayedNotes.map((item, index) => (
                                            <tr key={index}>
                                                <td><StatusBadge status={item.status} msg={item.description} /></td>
                                                <td style={{ fontWeight: 600 }}>
                                                    {formatSerieNumber(item)}
                                                </td>
                                                <td style={{ fontWeight: 500 }}>
                                                    {formatEmissionDate(item)}
                                                </td>
                                                <td style={{ fontWeight: 500 }}>
                                                    {item.taker ? item.taker.name : 'N/A'}
                                                </td>
                                                <td>
                                                    <div style={{ maxWidth: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.9rem' }} title={item.service ? item.service.description : "N/A"}>
                                                        {item.service ? item.service.description : "N/A"}
                                                    </div>
                                                </td>
                                                <td style={{ fontWeight: 600, color: '#0088cc' }}>
                                                    {item.service && item.service.value ? <Currency quantity={item.service.value} currency="BRL" /> : "N/A"}
                                                </td>
                                                <td><ChannelBadge channel={item.channel} /></td>
                                                <td>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                        {renderActions(item)}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </TableWrapper>
                            </DesktopOnly>
                        </React.Fragment>
                    )}
                </StyledCard>
                <Modal show={showCsvModal} onHide={() => { if (!uploadingCsv) { setShowCsvModal(false); setCsvResult(null); setCsvFile(null); setCsvPreview(null); setProgress(0); setCsvRowsData([]); } }} size={csvResult || csvPreview ? "lg" : "md"} backdrop={uploadingCsv ? "static" : true}>
                    <Modal.Header closeButton>
                        <Modal.Title><i className="fas fa-file-csv" style={{ color: '#026AA2' }}></i> Emissão em Lote (CSV)</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {!csvResult ? (
                            <div style={{ textAlign: 'center', padding: '24px' }}>
                                <p className="text-secondary mb-4">
                                    Selecione o arquivo <b>.csv</b> contendo as informações das notas fiscais a serem emitidas.
                                    <br />
                                    <button
                                        className="btn btn-link p-0 mt-2"
                                        style={{ fontSize: '0.85rem', textDecoration: 'none' }}
                                        onClick={downloadCsvTemplate}
                                    >
                                        <i className="fas fa-download"></i> Baixar planilha modelo (CSV)
                                    </button>
                                    <div className="mt-1">
                                        <button
                                            className="btn btn-link p-0"
                                            style={{ fontSize: '0.85rem', textDecoration: 'none', color: '#0088cc' }}
                                            onClick={() => setShowFinder(true)}
                                        >
                                            <i className="fas fa-search-dollar"></i> Não sabe qual código usar? Consulte nossa lista
                                        </button>
                                    </div>
                                </p>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".csv"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        setCsvFile(file);
                                        if (file) {
                                            const reader = new FileReader();
                                            reader.onload = (event) => {
                                                const text = event.target.result;
                                                const lines = text.split('\n').filter(line => line.trim() !== '');
                                                const previewData = [];
                                                const allRows = [];
                                                if (lines.length > 0) {
                                                    const head = lines[0].split(';');
                                                    for (let i = 1; i < lines.length; i++) {
                                                        const cols = lines[i].split(';');
                                                        let rowObj = {};
                                                        head.forEach((h, index) => {
                                                            rowObj[h.trim()] = cols[index] ? cols[index].trim() : '';
                                                        });
                                                        allRows.push(rowObj);
                                                        if (i <= 5) previewData.push(rowObj);
                                                    }
                                                    setCsvRowsData(allRows);
                                                    setCsvPreview({ header: head.map(h => h.trim()), rows: previewData, totalLines: allRows.length });
                                                }
                                            };
                                            reader.readAsText(file);
                                        } else {
                                            setCsvPreview(null);
                                            setCsvRowsData([]);
                                        }
                                    }}
                                    disabled={uploadingCsv}
                                />
                                {csvPreview && (
                                    <div className="mt-3" style={{ textAlign: 'left' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#344054' }}>Pré-visualização do Lote ({csvPreview.totalLines} notas prontas):</span>
                                        </div>
                                        <div style={{ maxHeight: '180px', overflowY: 'auto', border: '1px solid #E4E7EC', borderRadius: '6px', marginTop: '8px' }}>
                                            <table className="table table-sm table-striped m-0" style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                                                <thead style={{ background: '#F9FAFB', position: 'sticky', top: 0 }}>
                                                    <tr>
                                                        {csvPreview.header.map((h, i) => <th key={i}>{h}</th>)}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {csvPreview.rows.map((row, index) => (
                                                        <tr key={index}>
                                                            {csvPreview.header.map((h, i) => <td key={i}>{row[h]}</td>)}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        {csvPreview.totalLines > 4 && <div style={{ fontSize: '0.75rem', color: '#667085', marginTop: '4px' }}>Mostrando apenas as 4 primeiras linhas da planilha.</div>}
                                    </div>
                                )}
                                {uploadingCsv && (
                                    <div className="mt-4" style={{ textAlign: 'left' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontWeight: 600, color: '#344054', fontSize: '0.9rem' }}>
                                            <span>Processando pacote...</span>
                                            <span>{progress} de {csvRowsData.length}</span>
                                        </div>
                                        <div style={{ width: '100%', background: '#E4E7EC', borderRadius: '8px', height: '16px', overflow: 'hidden' }}>
                                            <div style={{
                                                width: `${(progress / csvRowsData.length) * 100}%`,
                                                background: '#027A48',
                                                height: '100%',
                                                transition: 'width 0.2s ease-in-out'
                                            }}></div>
                                        </div>
                                        <p className="mt-2 text-secondary text-center" style={{ fontSize: '0.85rem' }}>Operação em andamento. Por favor, mantenha a janela aberta até a conclusão.</p>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '24px', background: '#F9FAFB', padding: '16px', borderRadius: '8px' }}>
                                    <div style={{ textAlign: 'center' }}>
                                        <h3 style={{ color: '#027A48' }}>{csvResult.success_count}</h3>
                                        <span className="text-secondary">Enviadas com Sucesso</span>
                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        <h3 style={{ color: '#D92D20' }}>{csvResult.error_count}</h3>
                                        <span className="text-secondary">Falhas / Negadas</span>
                                    </div>
                                </div>
                                {csvResult.error_list && csvResult.error_list.length > 0 && (
                                    <div className="alert alert-danger" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                        <h6 style={{ fontWeight: 'bold' }}>Relatório de Erros:</h6>
                                        <ul style={{ paddingLeft: '20px', fontSize: '0.85rem' }}>
                                            {csvResult.error_list.map((err, idx) => (
                                                <li key={idx}>Linha {err.row} (CNPJ: {err.cpf_cnpj}): {JSON.stringify(err.error)}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        {!csvResult ? (
                            <ActionButton variant="primary" onClick={handleUploadCsv} disabled={uploadingCsv || !csvFile || csvRowsData.length === 0} style={{ width: '100%', padding: '12px', background: '#026AA2', borderColor: '#026AA2' }}>
                                Processar e Emitir Lote {csvPreview ? `(${csvPreview.totalLines} Notas)` : ''}
                            </ActionButton>
                        ) : (
                            <ActionButton variant="secondary" onClick={() => { setShowCsvModal(false); setCsvResult(null); setCsvFile(null); setCsvPreview(null); setProgress(0); setCsvRowsData([]); }} style={{ width: '100%', padding: '12px' }}>
                                Fechar e Ver Listagem
                            </ActionButton>
                        )}
                    </Modal.Footer>
                </Modal>
            </ScreenContent>
        </ScreenContainer>
    );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/list/index.jsx